//Javascript for WECAN applicant registration functionality
app.ApplicantRegistration = (
    function () {
        var register = {
            // RegisterStep1 page
            RegisterStep1: function () {
                var isRequestAlive = false;
                $(document).on("submit",
                    "form",
                    function (e) {
                        if (isRequestAlive) {
                            e.preventDefault();
                        } else {
                            isRequestAlive = true;
                        }
                    });
            },

            // RegisterStep2 page
            RegisterStep2: function () {
                $("#CurrentlyWorkForDistrict").change(function () {
                    util.console.log($("#CurrentlyWorkForDistrict"));
                    if (this.checked) {
                        $("#CurrentDistrict").attr("hidden", false);
                        $("#CurrentDistrict").show();
                    } else {
                        $("#CurrentDistrict").attr("hidden", true);
                        $("#CurrentDistrict").hide();
                    }
                });
                // check the key every 30 minutes
                setInterval(() => app.ApplicantRegistration.CheckRegistrationKey(), 1800000);

                // close logout modal listener
                $("#LogoutModal").on("hidden.bs.modal", function () {
                    $("#logoutForm").submit();
                });
                app.ApplicantRegistration.CesaMapInit();

                app.UserProfile.DistrictEmailValidationInit();
            },
            CesaMapInit: function (showLinks) {
                var currentlyFocusedCesa;

                $(".cesa-group-item").on("click keyup", function () {
                    // check if the user pressed spacebar or enter
                    // if they don't, then don't show the modal
                    if (event.code !== "Space" && event.code !== "Enter" && event.type === "keyup") {
                        event.preventDefault();
                        return false;
                    }

                    // set the currently focused cesa so that we can set the
                    // focus to the correct element when the modal is closed
                    currentlyFocusedCesa = $(this).attr("id");

                    var cesaUniqueId = {
                        "cesaUniqueId": $(this).data("cesa-unique-id"),
                        "showLinks": showLinks
                    };

                    var url = "/Account/ViewDistrictsForCesa";
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: cesaUniqueId,
                        success: function (data) {
                            $("#districtList").html(data);
                            $("#districtList").modal("show");
                        },
                        error: function (data) {
                        }
                    });
                });

                // handler for closing the cesa districts modal
                $("#districtList").on("hidden.bs.modal",
                    function () {
                        // focus the currently focused cesa on modal close
                        // this is to allow keyboard navigation through the cesa map svg
                        $("#" + currentlyFocusedCesa).focus();
                    });
            },
            // RegisterStep3 page
            RegisterStep3: function () {
                // check the key every 30 minutes
                setInterval(() => app.ApplicantRegistration.CheckRegistrationKey(), 1800000);

                // close logout modal listener
                $(document).on("hidden.bs.modal", function () {
                    $("#logoutForm").submit();
                });
            },

            RegisterStep4: function () {
                app.UserProfile.AccountRecoverySettingsInit();

                // check the key every 30 minutes
                setInterval(() => app.ApplicantRegistration.CheckRegistrationKey(), 1800000);

                // close logout modal listener
                $(document).on("hidden.bs.modal", function () {
                    $("#logoutForm").submit();
                });
            },

            CheckRegistrationKey: function () {
                // call controller method to check if the token is still valid
                // if yes, don't do anything
                // if no, log the user out and redirect to a "logged out" page
                var key = $("#Key").val();

                $.post("/Account/IsTokenValid", { "key": key }, function (data) {
                    if (data === "False") {
                        $("#LogoutModal").modal("show");
                    }
                });
            }
        }

        return register;
    }()
);